import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './style.scss';

const BLOCK_WIDTH = 8;
const GAP = 1;
const CONTAINER_WIDTH = 126; // твоя ширина scan-loader-block-progress-bar


interface ScanLoaderProps {
  label?: string;
  totalDuration?: number;
  onComplete?: () => void;
  eyePosition?: { x: number; y: number } | null;
}


export default function ScanLoader({
  label,
  totalDuration = 4,
  onComplete,
  eyePosition = null
}: ScanLoaderProps) {
  const [progress, setProgress] = useState(0);
  const [blocks, setBlocks] = useState<boolean[]>([]);
  
  const totalBlocks = Math.floor((CONTAINER_WIDTH + GAP) / (BLOCK_WIDTH + GAP));

  useEffect(() => {
    const initialBlocks = Array(totalBlocks).fill(false);
    initialBlocks[0] = true;
    setBlocks(initialBlocks);

    const intervalDuration = (totalDuration * 1000) / totalBlocks;
    let currentBlock = 0;

    const interval = setInterval(() => {
      if (currentBlock < totalBlocks) {
        setBlocks((prev) => {
          const newBlocks = [...prev];
          newBlocks[currentBlock] = true;
          return newBlocks;
        });

        const newProgress = ((currentBlock + 1) / totalBlocks) * 100;
        setProgress(newProgress);

        currentBlock++;
      } else {
        clearInterval(interval);
        onComplete?.();
      }
    }, intervalDuration);

    return () => clearInterval(interval);
  }, [totalDuration, onComplete, totalBlocks]);

  return (
    <div className='scan-loader-overlay'>
      <div className='blur-top'></div>
      <div className='blur-bottom'></div>
      <div className='blur-left'></div>
      <div className='blur-right'></div>
      <motion.div
        initial={{ opacity: 0, scale: 0.9, x: 0, y: 0  }}
        animate={{ opacity: 1, scale: 1, x: 0, y: 0  }}
        className='scan-loader-container'
      >
          <div className='scan-loader-frame'>
            <div className='scan-loader-crosshair-left' />
            <div className='scan-loader-crosshair-right' />
            <div className='scan-loader-crosshair-top' />
            <div className='scan-loader-crosshair-bottom' />

            <div className='scan-loader-label'>{label}</div>
          </div>

        <div className='scan-loader-block-progress-bar'>
          {blocks.map((isActive, index) => (
            <motion.div
              key={index}
              className={`scan-loader-block ${isActive ? 'active' : ''}`}
              animate={
                isActive
                  ? {
                      opacity: 1,
                    }
                  : {
                      opacity: 0,
                    }
              }
              transition={{
                duration: 0.2,
                ease: 'easeOut',
              }}
            />
          ))}
        </div>
      </motion.div>
    </div>
  );
}
